import Movable from '../../lib/jin/jwchartlib-v0/includes/mixins/Movable.mixin'

export default Movable